import React, { useMemo } from 'react';
import { Button } from 'primereact/button';
import useVehicleDistributionReport from './hooks/useVehicleDistributionReport';
import VehicleDistributionReportTable from './components/VehicleDistributionReportTable';
import { getColumns } from './helpers/getColumns';
import { useLanguage } from '../../../contexts/LanguageContext';
import { useLazyExportVehicleDistributionToExcelQuery } from '../../../api/endpoints/vehicleDistributionReport';
import GenericFileExportButton from '../../../components/common/GenericFileExportButton';

export default function VehicleDistributionReportPage() {
    const { th } = useLanguage();

    const {
        items,
        totalCount,
        isFetching,
        lazyParams,
        onPage,
        activeFilters,
        filterOptions,
        locale,
        handleFilterChange,
        resetFilters,
        sortField,
        sortOrder,
        onSort,
        exportParams
    } = useVehicleDistributionReport();

    const columns = useMemo(() => getColumns(th), [th]);

    return (
        <div className="card">
            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('vehicleDistributionReport.title')}</h1>
                <div className="flex gap-2">
                    <Button
                        icon="pi pi-filter-slash"
                        className="p-button-outlined p-button-secondary"
                        onClick={resetFilters}
                        tooltip={th('filter.reset')}
                        tooltipOptions={{ position: 'left' }}
                    />
                    <GenericFileExportButton
                        useExportQuery={useLazyExportVehicleDistributionToExcelQuery}
                        exportParams={exportParams}
                        buttonLabel={th('common.export')}
                        buttonClassName="p-button-success"
                        icon="pi pi-file-excel"
                        defaultFileName="AracDagitimRaporu"
                    />
                </div>
            </div>

            <VehicleDistributionReportTable
                columns={columns}
                items={items}
                totalCount={totalCount}
                loading={isFetching}
                lazyParams={lazyParams}
                onPage={onPage}
                sortField={sortField}
                sortOrder={sortOrder}
                onSortChange={onSort}
                activeFilters={activeFilters}
                onFiltersChange={handleFilterChange}
                filterOptions={filterOptions}
                locale={locale}
            />
        </div>
    );
}
